module.exports = "/images/only-logo.png?250f1549a5a0a432124987b378cd97f0";